import "./portfolioSlider.css";
import { Link } from 'react-router-dom';
// import { useState } from "react";

export default function PortfolioSlider({background, title, number, link}) {
    // const [background, setBackground] = useState();

    return (
            <section className="portfolio" style={{backgroundImage: `url(${background})`}}>
                <div className="portfolio__wrapper">
                    <h3>{title}</h3>
                    <div className="portfolio__number">
                        {number}
                    </div>

                    <Link to={`/${link}`}>
                    <div id="arrowAnim">
                        <div class="arrowSliding">
                            <div class="arrow"></div>
                        </div>
                        <div class="arrowSliding delay1">
                            <div class="arrow"></div>
                        </div>
                        <div class="arrowSliding delay2">
                            <div class="arrow"></div>
                        </div>
                        <div class="arrowSliding delay3">
                            <div class="arrow"></div>
                        </div>
                    </div>
                    </Link>
                </div>
            </section>
    )
}
